import React from 'react';
import { useSelector } from 'react-redux';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import authenticationSelector from '../../authentication/authenticationSelector';
import Authentication from '../../authentication/Authentication';

function Startpage() {
  const isAuthenticated = useSelector(authenticationSelector.isAuthenticated);

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
        padding: '24px',
        alignItems: 'center',
      }}
    >
      <Typography fontSize='1.5rem'>Willkommen im Dokutool</Typography>
      {isAuthenticated === false && <Authentication />}
    </Container>
  );
}

export default Startpage;
